const isAfter = ( value, vm ) => {
    if ( !value || !vm.validationParameter )
        return true;

    return new Date( value ) >= new Date( vm.validationParameter );
};

export default {
    isAfter
};